import React from 'react'

class UploadButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.onClick = this.onClick.bind(this)
        this.onDelete = this.onDelete.bind(this)
    }

    onClick(e) {
        const { name, id, onUpdate, editorRequest } = this.props

        editorRequest({
            method: 'assetmanager_select_image',
            callback: ({ src, srcThumb }) => onUpdate(id, { [name]: src }, this.props.payload),
        })
    }

    onDelete(e) {
        const { name, id, onUpdate } = this.props
        onUpdate(id, { [name]: '' }, this.props.payload)
    }

    render() {
        const { value } = this.props
        const imgPrevSt = {
            display: 'block',
            backgroundImage: `url(${value})`,
        }
        const bs = {}
        if (!value) {
            bs.width = '100%'
        }
        return (
            <div className="upload-group">
                <div className="side" style={bs}>
                    {value && <div className="img_prev" style={imgPrevSt}></div>}
                    <div className="contr_btn js-select __with_extra_icon" style={bs} onClick={this.onClick}>
                        <span className="pts_string pts_choose_image">Change</span>
                    </div>
                </div>
                {value && (
                    <div className="side">
                        <div className="contr_btn_extra_icon __delete js-delete" onClick={this.onDelete}></div>
                    </div>
                )}
            </div>
        )
    }
}

export default UploadButton
